import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ClippingStudioMamItem } from "app/js/src/domain/clipping-studio/clipping-studio-mam-item";

@Component({
  selector: "evrideo-clipping-studio-mam-graphic-card",
  templateUrl: "./clipping-studio-mam-graphic-card.component.html",
  styleUrls: ["./clipping-studio-mam-graphic-card.component.scss"],
})
export class ClippingStudioMamGraphicCardComponent {
  @Input() item!: ClippingStudioMamItem;
  @Input() showEditOverlay = false;
  @Output() edit = new EventEmitter<void>();

  onEditClick(event: MouseEvent): void {
    event.stopPropagation();
    this.edit.emit();
  }
}
